<template>
  <div>
    <router-view class="view" keep-alive transition transition-mode="out-in" />
    <page-listar v-if="isIndexOnly()" />
  </div>
</template>

<script>
import Listar from './Listar'

export default {
  name: 'mensagem-config',
  data () {
    return {
      title: 'Configurar Envio de Mensagens p/ Motoristas'
    }
  },
  components: {
    'page-listar': Listar
  },
  methods: {
    isIndexOnly () {
      return this.$router.currentRoute.path === '/mensagem-config' || this.$router.currentRoute.path === '/mensagem-config/'
    }
  },
  mounted () {
    this.$parent.$data.title = this.title
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/mensagem-config/index.vue